import { hyphenateHTMLSync } from "hyphen/fi"
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import Image from "@knowit-alma/common/src/components/atoms/Image/Image"

import styles from "./HeroCombo.module.scss"

const HeroCombo = ({ title, image, aspectRatio, caption = "" }) => {
  const striptags = require("striptags")

  return (
    <section
      className={`${styles.hero} section-break-out section-break-out-no-margins-mobile`}
    >
      <div className={`${styles.container} container-fluid container-capped`}>
        <Row className="mobile-bottom-margins tablet-bottom-margins">
          <Col
            lg={{ span: 6, offset: 1, order: 2 }}
            xl={{ span: 6, offset: 1, order: 2 }}
            className="col-xxl-5 order-xxl-2 offset-xxl-1 align-self-center"
          >
            <figure className={styles.image}>
              <Image
                image={image}
                aspectRatio={aspectRatio}
                widths={[313, 612, 750, 1080]}
              />
              {caption && (
                <figcaption className={styles.caption}>
                  {striptags(caption)}
                </figcaption>
              )}
            </figure>
          </Col>
          <Col
            lg={{ span: 5, offset: 0, order: 1 }}
            xl={{ span: 5, offset: 0, order: 1 }}
            className="col-xxl-4 order-xxl-1 offset-xxl-1 align-self-center"
          >
            <div className={styles.content}>
              <h1>
                {title ? hyphenateHTMLSync(title, { minWordLength: 16 }) : ""}
              </h1>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default HeroCombo
